module.exports = __webpack_public_path__ + "static/img/package_6.93ad7fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_6.jpg
// module id = PkuG
// module chunks = 1